var map = {
	"./components/alert/alert.stories.mdx": "./src/components/alert/alert.stories.mdx",
	"./components/author/author.stories.mdx": "./src/components/author/author.stories.mdx",
	"./components/avatar/avatar.stories.mdx": "./src/components/avatar/avatar.stories.mdx",
	"./components/badge/badge.stories.mdx": "./src/components/badge/badge.stories.mdx",
	"./components/button-swap/button-swap.stories.mdx": "./src/components/button-swap/button-swap.stories.mdx",
	"./components/button/button.stories.mdx": "./src/components/button/button.stories.mdx",
	"./components/calendar-date/calendar-date.stories.mdx": "./src/components/calendar-date/calendar-date.stories.mdx",
	"./components/card/card.stories.mdx": "./src/components/card/card.stories.mdx",
	"./components/checkbox/checkbox.stories.mdx": "./src/components/checkbox/checkbox.stories.mdx",
	"./components/cloud-cover/cloud-cover.stories.mdx": "./src/components/cloud-cover/cloud-cover.stories.mdx",
	"./components/comment-form/comment-form.stories.mdx": "./src/components/comment-form/comment-form.stories.mdx",
	"./components/comment/comment.stories.mdx": "./src/components/comment/comment.stories.mdx",
	"./components/dot-leader/dot-leader.stories.mdx": "./src/components/dot-leader/dot-leader.stories.mdx",
	"./components/event-log/event-log.stories.mdx": "./src/components/event-log/event-log.stories.mdx",
	"./components/event-summary/event-summary.stories.mdx": "./src/components/event-summary/event-summary.stories.mdx",
	"./components/footnote-group/footnote-group.stories.mdx": "./src/components/footnote-group/footnote-group.stories.mdx",
	"./components/footnote-link/footnote-link.stories.mdx": "./src/components/footnote-link/footnote-link.stories.mdx",
	"./components/footnote/footnote.stories.mdx": "./src/components/footnote/footnote.stories.mdx",
	"./components/ground-nav/ground-nav.stories.mdx": "./src/components/ground-nav/ground-nav.stories.mdx",
	"./components/heading/heading.stories.mdx": "./src/components/heading/heading.stories.mdx",
	"./components/icon/icon.stories.mdx": "./src/components/icon/icon.stories.mdx",
	"./components/input/input.stories.mdx": "./src/components/input/input.stories.mdx",
	"./components/pagination/pagination.stories.mdx": "./src/components/pagination/pagination.stories.mdx",
	"./components/sky-nav/sky-nav.stories.mdx": "./src/components/sky-nav/sky-nav.stories.mdx",
	"./components/subscribe/subscribe.stories.mdx": "./src/components/subscribe/subscribe.stories.mdx",
	"./components/table/table.stories.mdx": "./src/components/table/table.stories.mdx",
	"./design/brand.stories.mdx": "./src/design/brand.stories.mdx",
	"./design/colors.stories.mdx": "./src/design/colors.stories.mdx",
	"./design/defaults.stories.mdx": "./src/design/defaults.stories.mdx",
	"./design/favicons.stories.mdx": "./src/design/favicons.stories.mdx",
	"./design/icons/icons.stories.mdx": "./src/design/icons/icons.stories.mdx",
	"./design/illustrations.stories.mdx": "./src/design/illustrations.stories.mdx",
	"./design/modular-scale.stories.mdx": "./src/design/modular-scale.stories.mdx",
	"./design/themes.stories.mdx": "./src/design/themes.stories.mdx",
	"./docs/changelog.stories.mdx": "./src/docs/changelog.stories.mdx",
	"./docs/contributing.stories.mdx": "./src/docs/contributing.stories.mdx",
	"./docs/intro.stories.mdx": "./src/docs/intro.stories.mdx",
	"./objects/bio/bio.stories.mdx": "./src/objects/bio/bio.stories.mdx",
	"./objects/bunch/bunch.stories.mdx": "./src/objects/bunch/bunch.stories.mdx",
	"./objects/button-group/button-group.stories.mdx": "./src/objects/button-group/button-group.stories.mdx",
	"./objects/container/container.stories.mdx": "./src/objects/container/container.stories.mdx",
	"./objects/deck/deck.stories.mdx": "./src/objects/deck/deck.stories.mdx",
	"./objects/embed/embed.stories.mdx": "./src/objects/embed/embed.stories.mdx",
	"./objects/feature-group/feature-group.stories.mdx": "./src/objects/feature-group/feature-group.stories.mdx",
	"./objects/form-group/form-group.stories.mdx": "./src/objects/form-group/form-group.stories.mdx",
	"./objects/input-group/input-group.stories.mdx": "./src/objects/input-group/input-group.stories.mdx",
	"./objects/list/list.stories.mdx": "./src/objects/list/list.stories.mdx",
	"./objects/logo-group/logo-group.stories.mdx": "./src/objects/logo-group/logo-group.stories.mdx",
	"./objects/media/media.stories.mdx": "./src/objects/media/media.stories.mdx",
	"./objects/overview/overview.stories.mdx": "./src/objects/overview/overview.stories.mdx",
	"./objects/page/page.stories.mdx": "./src/objects/page/page.stories.mdx",
	"./objects/rhythm/rhythm.stories.mdx": "./src/objects/rhythm/rhythm.stories.mdx",
	"./prototypes/article-listing/articles.stories.js": "./src/prototypes/article-listing/articles.stories.js",
	"./prototypes/article-series/single-article.stories.js": "./src/prototypes/article-series/single-article.stories.js",
	"./prototypes/articles/articles.stories.js": "./src/prototypes/articles/articles.stories.js",
	"./prototypes/card-variations/card-variations.stories.js": "./src/prototypes/card-variations/card-variations.stories.js",
	"./prototypes/case-study-listings/case-study-listings.stories.js": "./src/prototypes/case-study-listings/case-study-listings.stories.js",
	"./prototypes/cloud-divider/clouds.stories.js": "./src/prototypes/cloud-divider/clouds.stories.js",
	"./prototypes/comment-thread/thread.stories.js": "./src/prototypes/comment-thread/thread.stories.js",
	"./prototypes/email-signup/signup.stories.js": "./src/prototypes/email-signup/signup.stories.js",
	"./prototypes/error/error.stories.mdx": "./src/prototypes/error/error.stories.mdx",
	"./prototypes/home-page/home-page.stories.js": "./src/prototypes/home-page/home-page.stories.js",
	"./prototypes/no-content/no-content.stories.js": "./src/prototypes/no-content/no-content.stories.js",
	"./prototypes/no-results/articles.stories.js": "./src/prototypes/no-results/articles.stories.js",
	"./prototypes/quotes/quotes.stories.js": "./src/prototypes/quotes/quotes.stories.js",
	"./prototypes/single-article/single-article.stories.js": "./src/prototypes/single-article/single-article.stories.js",
	"./prototypes/single-page/single-page.stories.js": "./src/prototypes/single-page/single-page.stories.js",
	"./prototypes/speaking-event/speaking.stories.js": "./src/prototypes/speaking-event/speaking.stories.js",
	"./prototypes/speaking-listing/speaking.stories.js": "./src/prototypes/speaking-listing/speaking.stories.js",
	"./prototypes/team/team.stories.js": "./src/prototypes/team/team.stories.js",
	"./tokens/aspect-ratio.stories.mdx": "./src/tokens/aspect-ratio.stories.mdx",
	"./tokens/breakpoint.stories.mdx": "./src/tokens/breakpoint.stories.mdx",
	"./tokens/color.stories.mdx": "./src/tokens/color.stories.mdx",
	"./tokens/font.stories.mdx": "./src/tokens/font.stories.mdx",
	"./tokens/layout.stories.mdx": "./src/tokens/layout.stories.mdx",
	"./tokens/line-height.stories.mdx": "./src/tokens/line-height.stories.mdx",
	"./tokens/modular-scale.stories.mdx": "./src/tokens/modular-scale.stories.mdx",
	"./tokens/motion.stories.mdx": "./src/tokens/motion.stories.mdx",
	"./tokens/opacity.stories.mdx": "./src/tokens/opacity.stories.mdx",
	"./tokens/sizes.stories.mdx": "./src/tokens/sizes.stories.mdx",
	"./utilities/border/border.stories.mdx": "./src/utilities/border/border.stories.mdx",
	"./utilities/display/display.stories.mdx": "./src/utilities/display/display.stories.mdx",
	"./utilities/rounded/rounded.stories.mdx": "./src/utilities/rounded/rounded.stories.mdx",
	"./utilities/size/size.stories.mdx": "./src/utilities/size/size.stories.mdx",
	"./utilities/spacing/spacing.stories.mdx": "./src/utilities/spacing/spacing.stories.mdx",
	"./utilities/text/text.stories.mdx": "./src/utilities/text/text.stories.mdx",
	"./vendor/prism/prism.stories.mdx": "./src/vendor/prism/prism.stories.mdx",
	"./vendor/wordpress/core-blocks.stories.mdx": "./src/vendor/wordpress/core-blocks.stories.mdx",
	"./vendor/wordpress/core-element-comparison.stories.mdx": "./src/vendor/wordpress/core-element-comparison.stories.mdx",
	"./vendor/wordpress/jetpack-blocks.stories.mdx": "./src/vendor/wordpress/jetpack-blocks.stories.mdx",
	"./vendor/wordpress/utilities.stories.mdx": "./src/vendor/wordpress/utilities.stories.mdx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src sync recursive ^\\.(?:(?:^|\\/|(?:(?:(?!(?:^|\\/)\\.).)*?)\\/)(?!\\.)(?=.)[^/]*?\\.stories\\.(js|mdx))$";